import moment from 'moment';

/**
 * MM/DD/YYYY only, from 1900 to today. Strict parsing: 08082008 or 8/8/2008 are not dates.
 * Shared by the blur validator (validateDateField) and the submit rule in Wizard, so a
 * date that is rejected on blur is also rejected on submit.
 */
export const isValidDate = value => {
  const text = `${value || ''}`;
  const date = moment(text, 'MM/DD/YYYY', true);

  return date.isValid() && Number(text.slice(-4)) >= 1900 && !date.isAfter(moment());
};

/** onFieldValidate handler for date inputs: marks the field errored on blur. */
export const validateDateField = (value, setHasError) => {
  if (!isValidDate(value)) {
    setHasError(true);
  }
};

const DATE = {
  placeholder: 'MM/DD/YYYY',
  maxLength: '10',
  // Rendered as data-format, which Wizard's submit validation keys off.
  format: 'date',
  errorMessage: 'Date must be in MM/DD/YYYY format, and year must be greater than 1900',
  helpText: 'Invalid Date',
};

const FIELD_PROPS = {
  PHONE: {
    placeholder: '10 digits',
    minLength: '10',
    maxLength: '10',
    inputMode: 'numeric',
    helpText: '10 digits, no dashes',
  },
  DATE,
  DOB: {
    ...DATE,
    label: 'Date of Birth',
  },
  ownerPercent: {
    type: 'number',
    label: 'Ownership percentage',
    placeholder: '%',
    errorMessage: 'Ownership percentage must be a number between 0 and 100',
    helpText: 'Invalid Percentage',
    max: 100,
  },
};

export default FIELD_PROPS;
